// Add your JS customizations here
window.onload = function () {
    require("./slick.js");
    require("./parallax.min.js");
    require("./homepage.js");
    require("./jde.js");
    require("./jde-support.js");
    require("./arva.js");
    require("./vigilab.js");
    require("./fileupload.js");
}


